import { render, staticRenderFns } from "./SupervisorTags.vue?vue&type=template&id=6ec2b003&scoped=true"
import script from "./SupervisorTags.vue?vue&type=script&lang=js"
export * from "./SupervisorTags.vue?vue&type=script&lang=js"
import style0 from "./SupervisorTags.vue?vue&type=style&index=0&id=6ec2b003&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec2b003",
  null
  
)

export default component.exports